import * as React from "react";
import { ReactNode } from "react";

interface ExpandableFabButtonProps {
  children: ReactNode;
  className?: string;
  title?: string;
  icon: string;
  banner: string;

  canCollapse: boolean;
  onCollapse?: () => void;
}

interface ExpandableFabButtonState {
  isExpanded: boolean;
}

export class ExpandableFabButton extends React.Component<
  ExpandableFabButtonProps,
  ExpandableFabButtonState
> {
  constructor(props: ExpandableFabButtonProps) {
    super(props);

    this.state = {
      isExpanded: false,
    };
  }

  render() {
    return (
      <span className={this.props.className + " expandable-fab-button"}>
        {!this.state.isExpanded && (
          <i className={this.props.icon + " button-icon"} onClick={this.expand.bind(this)} />
        )}
        {this.state.isExpanded && (
          <div className="expandable-fab-button-content">
            <div className="expandable-fab-button-banner">
              <i className={this.props.banner + " banner-icon"} />
            </div>
            <div className="panel with-shadow with-border v-flex no-wrap">
              <div className="panel-control">
                <i className="ic_close clickable" onClick={this.collapse.bind(this)} />
              </div>
              {this.props.title && (
                <div className="expandable-fab-button-title">{this.props.title}</div>
              )}
              <div className="content">{this.props.children}</div>
            </div>
          </div>
        )}
      </span>
    );
  }

  expand() {
    this.setState({ isExpanded: true });
  }

  collapse() {
    if (this.props.canCollapse) {
      if (this.props.onCollapse) this.props.onCollapse();
      this.setState({ isExpanded: false });
    }
  }
}
